var Header_announcement_bar_slider = document.querySelector('.Header_announcement_bar_slider');

if (Header_announcement_bar_slider) {
    new Swiper('.Header_announcement_bar_slider', {
    loop: true,
    grabCursor: true,
    spaceBetween: 0,
    slidesPerView: 1,
    watchSlidesProgress: true,
    draggable:!0,
    autoHeight:!1,
    watchOverflow:!0,
    threshold:10,
    mousewheel:{
        forceToAxis:!0
    },
    effect: "fade",
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    }
    })
}

function slideUpAnn(element, duration = 300) {
  element.style.height = element.offsetHeight + 'px';
  element.style.transitionProperty = 'height, margin, padding';
  element.style.transitionDuration = duration + 'ms';

  // Force browser to apply height before collapsing
  requestAnimationFrame(() => {
    element.style.height = '0';
    element.style.paddingTop = '0';
    element.style.paddingBottom = '0';
    element.style.marginTop = '0';
    element.style.marginBottom = '0';
  });

  // After animation ends, hide it completely
  setTimeout(() => {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    element.style.removeProperty('transition-duration');
    element.style.removeProperty('transition-property');
  }, duration);
}

document.addEventListener("DOMContentLoaded", () => {
  const closeBtn = document.querySelector(".Header_announcement_bar_close_new");
  const bar = document.querySelector(".Header_announcement_bar_main_new");

  if (closeBtn && bar) {
    closeBtn.addEventListener("click", () => {
      slideUpAnn(bar, 300); // 300ms animation
    });
  }
});
